import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { DashboardQuery, DashboardReservas } from "../typings";

export function useDashboardReservasPendentes(params: DashboardQuery) {
  return useQuery<DashboardReservas, AxiosError>(
    `/v1/dashboards/principal/reservas-pendentes-${params.dataFim}-${params.dataInicio}-${params.updatedAt}`,
    async () => {
      const { data } = await http.get<DashboardReservas>(
        "/v1/dashboards/principal/reservas-pendentes",
        {
          params,
        }
      );

      return data;
    }
  );
}
